// extracted by mini-css-extract-plugin
export default {"page":"gPMnPYuHE_6JOU8SvYiy"};